
import { examSvc } from '.';
import { currentChapter, chapterNav, chapters, questions, userProgress, chapterSwitched, examProgress } from '../stores';
import { authSvc } from './auth.service';
import { demoSvc } from './demo.service';
import { helpersSvc } from './helpers.service';

class ProgressService {
  constructor() {
    this._slug;
    this._userProgress = {};
    questions
      .subscribe(q => {
        if (!q) { return; }
        this.q = q;
        this.setNavItems();
      });
    chapters
      .subscribe(chs => {
        if (!chs) { return; }
        this.chapters = chs;
        this.setNavItems();
      });
    currentChapter
      .subscribe(ch => {
        if (!ch || this._slug === ch.slug) { return; }
        this._slug = ch.slug;
        this.currentChapter = ch;
        this.setNavItems();
      });
    userProgress
      .subscribe(up => {
        if (!up) { return; }
        this.userProgress = up;
        this.setNavItems();
      });
    examProgress.subscribe(ep => this.ep = ep);
    chapterSwitched.subscribe(() => this.setNavItems());
  }

  setUserProgress(up, updatedSlug) {
    const newUp = helpersSvc.clone(up);
    if (this._slug && (!updatedSlug || updatedSlug && !up.chapters[updatedSlug]?.status)) {
      examSvc.updateChapter();
    }
    userProgress.set(newUp);

    if (demoSvc.isDemoInstance()) {
      return;
    }
    if (JSON.stringify(this._userProgress) !== JSON.stringify(newUp)) {
      this._userProgress = newUp;
      authSvc.storeUserProgress(newUp);
    }
  }

  async setQuestionsProgress(allQuestions) {
    if (demoSvc.isDemoInstance()) {
      return;
    }
    await authSvc.storeQuestionsProgress(allQuestions, this.currentChapter.slug);
  }

  setNavItems() {
    if (!this.chapters || !this.currentChapter) {
      return;
    }
    const navItems = [
      {
        title: 'Video',
        slug: 'video',
        icon: 'play',
        isActive: () => !this.hasVideoPlayed()
      },
      {
        title: 'Regeln',
        slug: 'regeln',
        icon: 'university',
        isActive: () => this.hasVideoPlayed() && !this.hasAllRulesRead(),
      },
      {
        title: 'Prüfung',
        slug: 'pruefung',
        icon: 'user',
        isActive: () => {
          // addFinishedNav();
          return this.hasVideoPlayed() && this.hasAllRulesRead() && !this.examFinished();
        }
      },
      {
        title: 'Fertig',
        slug: 'beantwortet',
        icon: 'check',
        isClickable: () => this.hasVideoPlayed() && this.hasAllRulesRead() && this.examFinished(),
        isActive: () => this.hasVideoPlayed() && this.hasAllRulesRead() && this.examFinished()
      }
    ];
    // console.log('chapterNav', JSON.stringify(navItems.filter(d => d.isActive()).map(d => ({t: d.title, active: d.isActive()}))));
    chapterNav.set(navItems);
  }

  hasVideoPlayed() {
    return this.currentChapter && this.userProgress?.chapters[this.currentChapter.slug]?.videoPlayed;
  }
  
  getReadRules() {
    return this.currentChapter && this.userProgress?.chapters[this.currentChapter.slug]?.rulesRead;
  }

  hasAllRulesRead() {
    return this.currentChapter?.rules && this.userProgress?.chapters && this.currentChapter?.rules.length <= Object.keys(this.userProgress?.chapters[this.currentChapter?.slug]?.rulesRead || {}).length;
  }

  allQuestionsAnswered() {
    return this.q && this.q.filter(q => q.fixated).length == this.q.length;
  }

  examFinished() {
    return ['success', 'failed'].includes(this.userProgress?.chapters[this.currentChapter?.slug]?.status);
  }

  allExamsFinished() {
    if (this.ep) {
      return Object.keys(this.ep).every((key) => this.ep[key] === true);
    }
    return false;
  }
}
export const progressSvc = new ProgressService();
